<template>
	<sf-modal-layout :show="display" :title="getMessage_(title)" :closeModal="closeModal" size="l">
		<el-row :gutter="24">
			<el-col class="ml-2" style="height: 200px">
				<div class="sf-table">
					<table class="qms-table">
						<tbody>
							<tr>
								<th>Error Message</th>
							</tr>
							<tr>
								<td>
									<textarea
										class="excel-file__error__text addScroll py-2"
										style="height: 150px; width: 860px; border: none !important"
										v-model="errMsg"
										readonly
									/>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</el-col>
		</el-row>
		<template v-slot:footer>
			<!-- 진행하지 않음  -->
			<sf-button line :onClick="closeModal">
				{{ getMessage_('QWCC001992') }}
			</sf-button>
			<!-- 무시하고 진행 -->
			<sf-button line color="error" icon="error" :onClick="saveAction" style="width: fit-content !important">
				{{ getMessage_('QWCC001991') }}
			</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/fcku/FwdCkuTest/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			title: 'QWCC001286',
			display: false,
			errMsg: '',
			flag: ''
		};
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		saveAction() {
			this.$emit('keepGoing', this.flag);
			this.closeModal();
		},
		open(param) {
			this.display = true;
			this.errMsg = '';
			//console.log('this.attentionList', this.attentionList);
			if (param) {
				this.flag = param.flag;
				this.errMsg =
					param.okList?.reduce(
						(prev, curr) =>
							(prev += this.$sf_formatString(this.getMessage_('QWCC001993'), [this.getMessage_(curr), this.getMessage_(curr)]) + '\n'),
						this.errMsg
					) + '\n';
				this.errMsg = param.ngList?.reduce(
					(prev, curr) =>
						(prev += this.$sf_formatString(this.getMessage_('QWCC001994'), [this.getMessage_(curr), this.getMessage_(curr)]) + '\n'),
					this.errMsg
				);
			}
		},
		closeModal() {
			this.display = false;
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed
	}
};
</script>
